import { BaseQueryParams } from 'types/types';
import { axiosInstance } from './apiCommon';
import { ToolOwnerToolListItem } from 'types/tools/tool-owners/ToolOwnerToolListItem';
import { ToolForOwnerModel } from 'types/tools/tool-owners/ToolForOwnerModel';

export const getCompanyOwnedTools = async (companyId: string, params: BaseQueryParams) =>
  (
    await axiosInstance.get<ToolOwnerToolListItem[]>(
      `/api/v1/company-owned-tools/all-for-company/${encodeURIComponent(companyId)}`,
      params
    )
  ).data;

export const getToolForOwner = async (toolId: string, params: BaseQueryParams) =>
  (await axiosInstance.get<ToolForOwnerModel>(`/api/v1/company-owned-tools/${encodeURIComponent(toolId)}`, params)).data;
